<div>
  <pas-button-round
    [color]="pasButtonRoundColor.DARK"
    (click)="onClick($event)"
    icon="mode_edit"
    size="small"></pas-button-round>
</div>
